import { render, staticRenderFns } from "./Profile_Desktop.vue?vue&type=template&id=4dc0de02&scoped=true&"
import script from "./Profile_Desktop.vue?vue&type=script&lang=js&"
export * from "./Profile_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./Profile_Desktop.vue?vue&type=style&index=0&id=4dc0de02&prod&lang=css&"
import style1 from "./Profile_Desktop.vue?vue&type=style&index=1&id=4dc0de02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc0de02",
  null
  
)

export default component.exports